import type { ReactNode } from 'react'

import { Button, Col, Row, Space, Typography } from 'antd'
import React from 'react'

export const GroupAccountWrapper = ({
  children,
  withCreate = false,
  creating = false,
  onSave,
  onCancel,
  onClick,
  loading
}: {
  children: ReactNode
  withCreate?: boolean
  creating?: boolean
  onSave?: () => void
  onCancel?: () => void
  onClick?: () => void
  loading?: boolean
}): React.JSX.Element => {
  return (
    <Row className='border p-4 rounded-lg w-full'>
      <Col span={24} className='w-full'>
        <Row justify='space-between'>
          <Col>
            <Typography.Title
              level={5}
              className='font-lato tracking-wide uppercase text-[9.5px] font-semibold text-lucent-gray mb-2'
            >
              GROUP Account
            </Typography.Title>
          </Col>
          {withCreate && (
            <Col>
              {creating ? (
                <Space>
                  <Button
                    type='link'
                    htmlType='reset'
                    className='rounded-md'
                    onClick={event => {
                      event.preventDefault()
                      onCancel?.()
                    }}
                  >
                    Cancel
                  </Button>

                  <Button
                    type='primary'
                    htmlType='submit'
                    loading={loading}
                    onClick={event => {
                      event.preventDefault()
                      onSave?.()
                    }}
                  >
                    Save
                  </Button>
                </Space>
              ) : (
                <Button onClick={onClick}>+</Button>
              )}
            </Col>
          )}
        </Row>
        <Col className='w-full'>{children}</Col>
      </Col>
    </Row>
  )
}
